import {cn} from "@/lib/utils";
import {formatBuildLabel} from "@/src/modules/core/lib/format-build-label";

type AppVersionInfoProps = {
  className?: string;
  /** Sidebar collapsed: version string only. */
  compact?: boolean;
  /** Version and build on one line (e.g. account popover). */
  inline?: boolean;
  companyTimezone?: string | null;
};

export function AppVersionInfo({
  className,
  compact = false,
  inline = false,
  companyTimezone,
}: AppVersionInfoProps) {
  const buildLabel = formatBuildLabel(APP_BUILD_ID, companyTimezone);

  if (inline) {
    return (
      <p
        className={cn(
          "text-center text-xs text-muted-foreground",
          className,
        )}
      >
        Version: {APP_VERSION} · Build: {buildLabel}
      </p>
    );
  }

  return (
    <p
      className={cn(
        "flex flex-col items-center justify-center gap-0.5 text-center text-xs text-muted-foreground",
        className,
      )}
    >
      {compact ? (
        <span>{APP_VERSION}</span>
      ) : (
        <>
          <span>Version: {APP_VERSION}</span>
          <span>Build: {buildLabel}</span>
        </>
      )}
    </p>
  );
}
